import { FormattedMessage } from 'react-intl';

type ServiceInfoDialogMenuItemProps = {
    chapter: string;
    activeChapter: string;
    onClick: React.MouseEventHandler<HTMLElement>;
    trackingLabel: string;
};

export const ServiceInfoDialogMenuItem = ({ chapter, activeChapter, onClick }: ServiceInfoDialogMenuItemProps) => (
    // biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
    <span className={activeChapter === chapter ? 'active' : undefined} onClick={onClick} data-name={chapter}>
        <FormattedMessage id={`intl-msg:network.serviceInfo.${chapter}`} />
    </span>
);
